// Axios
import Axios from "./axios";

export const fetchTags = () => {
  return new Promise((resolve, reject) => {
    const data = Axios.get(`/tag`);
    resolve(data);
  });
};
